module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJlMzNkMjY1ZjVhNTIzYTlkMzU5OGI5ZjY4NTMxOWMyNi5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icons/turn-arrow.svg
// module id = 215
// module chunks = 0